import { Form, Icon, Upload } from 'antd';
import React, { Fragment, useCallback } from 'react';
import validateFile from '../../../../../../helpers/validateFile';
import ContractorRooms from '../ContractorRooms/ContractorRooms';

const SecondStep = ({
  getFieldDecorator,
  setFieldsValue,
  getFieldValue,
  editingCounterparty,
  fileList,
  setFileList,
}) => {
  const beforeUpload = useCallback(
    (file) => {
      const validated = validateFile(file);
      if (!validated) {
        return false;
      }
      setFileList((fileList) => [...fileList, file]);
      return false;
    },
    [setFileList]
  );
  const onRemove = useCallback(
    (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    [setFileList, fileList]
  );
  return (
    <>
      {getFieldDecorator('landLordOffices', {
        preserve: true,
        initialValue: editingCounterparty?.landLordOffices,
      })(<Fragment />)}
      <Form.Item label="Собственник">
        <ContractorRooms
          editingCounterparty={editingCounterparty}
          formKey="landLordOffices"
          setFieldsValue={setFieldsValue}
          getFieldValue={getFieldValue}
        />
      </Form.Item>
      <Form.Item>
        <Upload.Dragger
          name="file"
          height={64}
          fileList={fileList}
          multiple
          beforeUpload={beforeUpload}
          onRemove={onRemove}
        >
          <Icon type="file-add" theme="outlined" /> перетащите файлы сюда, или
          нажмите, чтобы выбрать
        </Upload.Dragger>
      </Form.Item>
    </>
  );
};

export default SecondStep;
